import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Header from "../layout/Header";
import { showLoading } from "../../../actions/action_loading";
import CheckboxInput from "../common/CheckboxInput";
import ErrorAlert from "../common/ErrorAlert";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import { GOCHI_KID_PATH } from "../../../constants";
import { log } from "../../../utils";
import { showError } from "../../../actions/action_error_alert";
import DonateService from "../../../api/services/GochiKid/DonateService";
import { HTTP_API } from "../../../api/HttpClient";

function DonateBankTransferATM(props) {
  const [policyChecked, setPolicyChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const history = useHistory();
  const match = useRouteMatch();
  const location = useLocation();
  const destination = match.params.destination;
  const inputPath = `${GOCHI_KID_PATH}/support/choice/${destination}/input${window.location.search}`;
  const previousPath = location.state?.previousPath;
  const previousPathConfirm = location.state?.previousPathConfirm;

  const goToComplete = async () => {
    props.showLoading(true);
    const response = await DonateService.getDonateStatus(
      props.bankTransferATMData.merchantPaymentId
    );

    if (response.status === HTTP_API.SUCCESS) {
      props.showLoading(false);

      if (response.data?.status === "CHECKOUT_SUCCESS") {
        setErrorMessage("");
        history.replace(
          `${GOCHI_KID_PATH}/support/choice/${destination}/complete?merchantPaymentId=${props.bankTransferATMData.merchantPaymentId}`
        );
      } else if (response.data?.status === "WAIT_CHECKOUT") {
        setErrorMessage(
          <>
            お振込みの確認ができませんでした。
            <br />
            振込手続きがお済みでない場合は、まず振込を完了してください。
            <br />
            既にお振込み済みの場合は、お手数ですが、しばらく時間をおいてから再度ご確認をお願いいたします。
          </>
        );
      } else {
        setErrorMessage("");
        props.showError(true, "エラーが発生しました。", "");
      }
    } else {
      setErrorMessage("");
      props.showLoading(false);
      props.showError(true, "エラーが発生しました。", "");
    }
  };

  useEffect(() => {
    log("DonateBankTransferATM componentDidMount");

    if (
      !props.donateAmount ||
      !(
        props.bankTransferATMData && props.bankTransferATMData.merchantPaymentId
      )
    ) {
      history.replace(inputPath);
      return;
    }

    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      <main className="page-wrapper">
        <div className="page-content donate-payment donate-transfer-atm">
          <div className="font-family-rounded title-donate text-center color-2F1A1C mb-3">
            お振込み情報
          </div>

          <table className="donate-transfer-atm-table">
            <tbody>
              <tr>
                <td className="title">収納機関番号</td>
                <td>{props.bankTransferATMData?.shunoKikanNo || ""}</td>
              </tr>
              <tr>
                <td className="title">お客様番号</td>
                <td>{props.bankTransferATMData?.customerNo || ""}</td>
              </tr>
              <tr>
                <td className="title">確認番号</td>
                <td>{props.bankTransferATMData?.confirmNo || ""}</td>
              </tr>
              <tr>
                <td className="title">決済金額</td>
                <td>
                  {props.donateAmount
                    ? `${props.donateAmount.toLocaleString()}円`
                    : ""}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="payment-warning mt-2">
            <div className="payment-warning-icon">
              <svg
                width="25"
                height="24"
                viewBox="0 0 26 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.68036 21.1482H20.4479C22.0602 21.1482 23.0653 19.4782 22.2591 18.1482L14.3754 5.13825C13.5692 3.80825 11.559 3.80825 10.7528 5.13825L2.86908 18.1482C2.06291 19.4782 3.06801 21.1482 4.68036 21.1482ZM12.5641 14.1482C11.9883 14.1482 11.5171 13.6982 11.5171 13.1482V11.1482C11.5171 10.5982 11.9883 10.1482 12.5641 10.1482C13.14 10.1482 13.6111 10.5982 13.6111 11.1482V13.1482C13.6111 13.6982 13.14 14.1482 12.5641 14.1482ZM13.6111 18.1482H11.5171V16.1482H13.6111V18.1482Z"
                  fill="#F9AC39"
                />
              </svg>
            </div>
            <div className="payment-warning-text">
              このお振込情報は一度限り有効で、発行日の翌日までご利用いただけます。
              <br />
              AＴＭでのお手続きが翌々日以降になった場合、振込完了ボタンを押下されてもエラーとなってしまいますのでご注意ください。
              <br />
              <br />
              お手続きが翌々日以降になるご予定の場合は、お手数ですが最初からお手続きをお願いいたします。
            </div>
          </div>

          <div className="d-flex justify-content-center mt-32px">
            <CheckboxInput
              checked={policyChecked}
              onChange={() => setPolicyChecked((prev) => !prev)}
            >
              振込を完了しました
            </CheckboxInput>
          </div>

          {!!errorMessage && (
            <ErrorAlert className="mt-2">{errorMessage}</ErrorAlert>
          )}

          <div className="mt-32px">
            <button
              className="btn-primary btn-size-md w-100 btn-check-complete"
              disabled={!policyChecked}
              onClick={goToComplete}
            >
              完了画面へ
              <i className="icon-next-destination" />
            </button>
          </div>
          <div className="mt-4 text-center">
            <button
              className="btn-link fw-400 border-0 p-0"
              onClick={() =>
                history.replace(previousPath, {
                  previousPath: previousPathConfirm,
                })
              }
            >
              前の画面に戻る
            </button>
          </div>
        </div>
      </main>
    </>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
  paymentMethod: state.paymentMethod,
  donateAmount: state.gochiKid.donate.donateAmount,
  bankTransferATMData: state.gochiKid.donate.bankTransferATMData,
});

const mapDispatchToProps = (dispatch) => ({
  showLoading: (showing) => dispatch(showLoading(showing)),
  showError: (showing, title, content, buttonName, gotoUrl) =>
    dispatch(showError(showing, title, content, buttonName, gotoUrl)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DonateBankTransferATM);
